document.addEventListener('DOMContentLoaded', () => {
  const bundleOptions = document.querySelectorAll('input[name="bundle"]');
  const addToCartButton = document.querySelector('.product-form__cart-submit');
  const productId = document.querySelector('input[name="product-id"]').value;
  const quantityInput = document.getElementById(`Quantity-${productId}`);
  const quantityInputForm = document.querySelector('.product__meta .quantity-input .quantity-input__input');
  const stickyBar = document.querySelector(".sticky-atc-bar__price");

  let bundleOffers = [...bundleOptions].map(option => ({
    quantity: parseInt(option.getAttribute('data-bundle-quantity')),
    element: option,
    priceWrapper: option.closest('.bundle-option').querySelector('.price-wrapper') 
  }));

  let selectedBundle = bundleOffers[0];

  function updateQuantityInput() {
    if (quantityInput) {
      quantityInput.value = document.querySelector(".bundle-options_wrapper .bundle-option input[type=radio]:checked").getAttribute("value");
      quantityInputForm.value = document.querySelector(".bundle-options_wrapper .bundle-option input[type=radio]:checked").getAttribute("value");
    }
  }

  function updateAddToCartButton() {
    const addToCartButtonSpan = addToCartButton.querySelector('span');
    var addToCartPrice = addToCartButtonSpan.querySelector(".price-wrapper");
    var selectedBundleComparePrice = document.querySelector(".bundle-options_wrapper .bundle-option input[type=radio]:checked+div .discounted-price s");
    var selectedBundleReduction = document.querySelector(".bundle-options_wrapper .bundle-option input[type=radio]:checked+div .description_bundle.discount");

    if (selectedBundleComparePrice){
      var selectedBundleNormalPrice = document.querySelector(".bundle-options_wrapper .bundle-option input[type=radio]:checked+div .original-price");
    }else{
      var selectedBundleNormalPrice = document.querySelector(".bundle-options_wrapper .bundle-option input[type=radio]:checked+div .price-wrapper.no-discount");
    }
        
    if (!!addToCartPrice === false){
      if (selectedBundleComparePrice){
        addToCartButtonSpan.insertAdjacentHTML("beforeend", '<div class="price-wrapper"><span class="original-price">'+ selectedBundleNormalPrice.textContent +'</span><span class="discounted-price"><s>'+ selectedBundleComparePrice.textContent +'</s></span><p class="description_bundle discount rte rte--product font-bold ff-body fs-body-75">'+ selectedBundleReduction.textContent +'</p></div>');
        if (stickyBar){
          stickyBar.querySelector("span[data-price]").textContent = selectedBundleNormalPrice.textContent.replace('.', ',');
          stickyBar.querySelector("s[data-compare-price]").textContent = selectedBundleComparePrice.textContent.replace('.', ',');
        }
      }else{
        addToCartButtonSpan.insertAdjacentHTML("beforeend", '<div class="price-wrapper"><span class="original-price">'+ selectedBundleNormalPrice.textContent +'</span><span class="discounted-price"><s></s></span><p class="description_bundle discount rte rte--product font-bold ff-body fs-body-75"></p></div>');
        if (stickyBar){
          stickyBar.querySelector("span[data-price]").textContent = selectedBundleNormalPrice.textContent.replace('.', ','); 
          stickyBar.querySelector("s[data-compare-price]").textContent = "";
        }
      }
    }else{
      if (selectedBundleComparePrice){
        addToCartPrice.querySelector(".original-price").textContent = selectedBundleNormalPrice.textContent.replace('.', ',');
        addToCartPrice.querySelector(".discounted-price s").textContent = selectedBundleComparePrice.textContent.replace('.', ',');
        addToCartPrice.querySelector(".description_bundle.discount").textContent = selectedBundleReduction.textContent.replace('.', ',');
        if (stickyBar){
          stickyBar.querySelector("span[data-price]").textContent = selectedBundleNormalPrice.textContent.replace('.', ',');
          stickyBar.querySelector("s[data-compare-price]").textContent = selectedBundleComparePrice.textContent.replace('.', ',');
        }
      }else{
        addToCartPrice.querySelector(".original-price").textContent = selectedBundleNormalPrice.textContent.replace('.', ',');
        addToCartPrice.querySelector(".discounted-price s").textContent = "";
        addToCartPrice.querySelector(".description_bundle.discount").textContent = "";
        if (stickyBar){
          stickyBar.querySelector("span[data-price]").textContent = selectedBundleNormalPrice.textContent.replace('.', ',');
          stickyBar.querySelector("s[data-compare-price]").textContent = "";
        }
      }
    }
  }

  const resetPageState = () => {
    selectedBundle = bundleOffers[0];
    selectedBundle.element.checked = true;
    updateQuantityInput();
    updateAddToCartButton();
  };

  resetPageState();

  bundleOptions.forEach(option => {
    option.addEventListener('change', (e) => {
      const newQuantity = parseInt(e.target.getAttribute('data-bundle-quantity'));
      selectedBundle = bundleOffers.find(offer => offer.quantity === newQuantity);
      updateQuantityInput();
      updateAddToCartButton();
    });
  });


  var buttonOption = document.querySelectorAll('.product__variants-wrapper .product__chip');
  
  for (var i = 0; i < buttonOption.length; i++) {
    buttonOption[i].addEventListener('click', function(event) {
      var currentTarget = event.currentTarget;
      var activeVariantValue = currentTarget.getAttribute("data-option-value");
      var activeVariantId = document.querySelector('#variant-selector option[title-variant="'+ activeVariantValue +'"]').getAttribute("value");
      
      var bundleDataElement = document.getElementById('variant-' + activeVariantId + '-bundle-data');
      var bundleImagesElement = document.getElementById('variant-' + activeVariantId + '-bundle-images');
      
      if (bundleDataElement) {
        var bundleData = JSON.parse(bundleDataElement.textContent);
        updateBundleContent(bundleData);
      }
      
      if (bundleImagesElement) {
        var bundleImages = JSON.parse(bundleImagesElement.textContent);
        updateBundleImages(bundleImages);
      }

      updateQuantityInput();
      updateAddToCartButton();
    }); 
  }
  
  function updateBundleContent(bundleData) {
    var bundleOptions = document.querySelectorAll('.bundle-option');
    
    bundleOptions.forEach(function(option, index) {
      if (bundleData.bundle[index]) {
        var titleElement = option.querySelector('.title_bundle');
        if (titleElement) {
          titleElement.innerHTML = bundleData.bundle[index].title.replace(' (', '<br> (');
        }
        
        var descriptionElement = option.querySelector('.description_bundle:not(.discount)');
        if (descriptionElement) {
          descriptionElement.textContent = bundleData.bundle[index].description;
        }
        
        var priceWrapper = option.querySelector('.price-wrapper');
        if (priceWrapper) {
          var basePrice = document.querySelector(".product__block--product-header-inner .product__price span[data-price]").textContent.replace(",",".").replace("€",""); 
          var quantity = bundleData.bundle[index].quantity;
          var originalTotal = (basePrice * quantity).toFixed(2);
          var discountPercentage = bundleData.bundle[index].discount_percentage;
          
          if (discountPercentage > 0) {
            var discountedTotal = (originalTotal * (1 - discountPercentage / 100)).toFixed(2);
            
            priceWrapper.innerHTML = 
              '<span class="original-price">' + discountedTotal.replace('.', ',') + '€</span>' +
              '<span class="discounted-price"><s>' + originalTotal.replace('.', ',') + '€</s></span>' +
              '<p class="description_bundle discount rte rte--product font-bold ff-body fs-body-75">- ' + discountPercentage + '%</p>';
          } else {
            priceWrapper.innerHTML = '<span class="price-wrapper no-discount">' + originalTotal.replace('.', ',') + '€</span>';
          }
        }
        
        var radioInput = option.querySelector('input[type="radio"]');
        if (radioInput) {
          radioInput.setAttribute('data-bundle-quantity', bundleData.bundle[index].quantity);
          radioInput.setAttribute('value', bundleData.bundle[index].quantity);
        }
      }
    });
  }
  
  function updateBundleImages(bundleImages) {    
    var bundleOptions = document.querySelectorAll('.bundle-option');
    
    bundleOptions.forEach(function(option, index) {
      var imageIndex = option.querySelector('input[name="bundle"]').getAttribute("data-bundle-quantity");
      
      if (bundleImages[imageIndex]) {
        var imageElement = option.querySelector('.image_bundle img');
        
        if (imageElement) {
          imageElement.src = bundleImages[imageIndex];
          
          var radioInput = option.querySelector('input[type="radio"]');
          if (radioInput) {
            var quantity = radioInput.getAttribute('data-bundle-quantity');
            imageElement.alt = "Bundle option " + quantity;
          }
        }
      }
    });
  }  
});
